<script setup lang="ts">
import { NxtSkeleton } from '@future-harry/nxt-styles';
</script>

<template>
   <section :class="['jobs-loading']">
      <NxtSkeleton v-for="n in 6" :key="n" />
   </section>
</template>

<style scoped lang="scss">
.jobs-loading {
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
   grid-auto-rows: min-content;
   gap: var(--nxt-gutter-large);
}
</style>
